import { defineEntity, custom } from './_helpers.js';

export default defineEntity('formTask', {
    assigned: custom({ scope: 'state' }),
});
